import { render } from "./TableResultado.vue?vue&type=template&id=6a620a03"
import script from "./TableResultado.vue?vue&type=script&lang=js"
export * from "./TableResultado.vue?vue&type=script&lang=js"

import "./TableResultado.vue?vue&type=style&index=0&id=6a620a03&lang=css"

import exportComponent from "C:\\Users\\User\\Documents\\PROJETOS - LEFISC\\front_revisor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__